import React from "react";
import "./orderHeader.css";
import search from "../../../../Assets/search.svg";
import { getRestaurantName } from "../../../../auth/AuthHandler";

const OrderHeaders = ({ searchQuery, handleSearchChange, onBack }) => {
  const restaurantName = getRestaurantName();

  return (
    <header className="Order-header">
       <button className="header-back-btn" onClick={onBack}>
          Back To Restaurants
        </button>
      <div className="heading-text">
        <h1>Orders Management - {restaurantName}</h1>
      </div>
      <div className="heading-profile">
        <div className="search-bar">
          <input
            type="text"
            placeholder="Search Order id"
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </div>
      </div>
    </header>
  );
};

export default OrderHeaders;
